import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import AuditPage from "@/pages/AuditPage";
import ReportPage from "@/pages/ReportPage";
import PricingPage from "@/pages/PricingPage";
import SampleReportPage from "@/pages/SampleReportPage";
import SharedReportPage from "@/pages/SharedReportPage";
import AdminBlueprintPage from "@/pages/AdminBlueprintPage";
import BlueprintDashboard from "@/pages/BlueprintDashboard";
import AdminGapAnalysisPage from "@/pages/AdminGapAnalysisPage";
import GapAnalysisScorecard from "@/pages/GapAnalysisScorecard";

function App() {
  return (
    <div className="App min-h-screen bg-[#f8f9fa]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/audit" element={<AuditPage />} />
          <Route path="/report/:auditId" element={<ReportPage />} />
          <Route path="/share/:auditId" element={<SharedReportPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/sample" element={<SampleReportPage />} />
          <Route path="/admin/blueprint" element={<AdminBlueprintPage />} />
          <Route path="/blueprint/:blueprintId" element={<BlueprintDashboard />} />
          <Route path="/admin/gap-analysis" element={<AdminGapAnalysisPage />} />
          <Route path="/gap-analysis/:analysisId" element={<GapAnalysisScorecard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
